import * as THREE from 'three';
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js';

// Genera un modelo 3D (.glb) "tarjeta" a partir de una sola foto del plato:
// una placa delgada con la foto en la cara frontal, lista para verse en AR con
// model-viewer. No reconstruye la forma real del plato (eso requeriría IA de
// reconstrucción 3D paga y poco confiable para comida) pero da una vista AR
// real, generada al instante y sin costo, apenas se sube la foto.
export function generateFoodCardGLB(imageFile) {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(imageFile);
    const img = new Image();

    img.onload = () => {
      try {
        const aspect = img.width / img.height || 1;
        const width = 1; // metro de referencia; model-viewer escala según el visor AR
        const height = width / aspect;
        const thickness = 0.02;

        const scene = new THREE.Scene();

        const loader = new THREE.TextureLoader();
        loader.load(
          objectUrl,
          (texture) => {
            try {
              texture.colorSpace = THREE.SRGBColorSpace;

              const geometry = new THREE.BoxGeometry(width, height, thickness);
              const sideMaterial = new THREE.MeshStandardMaterial({ color: 0xf5f5f0, roughness: 0.85 });
              const frontMaterial = new THREE.MeshStandardMaterial({ map: texture, roughness: 0.55 });
              // Orden de caras de BoxGeometry: +x, -x, +y, -y, +z, -z
              const materials = [sideMaterial, sideMaterial, sideMaterial, sideMaterial, frontMaterial, sideMaterial];
              const mesh = new THREE.Mesh(geometry, materials);
              scene.add(mesh);

              const light1 = new THREE.HemisphereLight(0xffffff, 0x555555, 1.4);
              scene.add(light1);
              const light2 = new THREE.DirectionalLight(0xffffff, 0.6);
              light2.position.set(0.5, 1, 1);
              scene.add(light2);

              const exporter = new GLTFExporter();
              exporter.parse(
                scene,
                (result) => {
                  URL.revokeObjectURL(objectUrl);
                  resolve(new Blob([result], { type: 'model/gltf-binary' }));
                },
                (error) => {
                  URL.revokeObjectURL(objectUrl);
                  reject(error);
                },
                { binary: true }
              );
            } catch (err) {
              URL.revokeObjectURL(objectUrl);
              reject(err);
            }
          },
          undefined,
          (err) => {
            URL.revokeObjectURL(objectUrl);
            reject(err);
          }
        );
      } catch (err) {
        URL.revokeObjectURL(objectUrl);
        reject(err);
      }
    };

    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('No se pudo leer la imagen'));
    };

    img.src = objectUrl;
  });
}